import React, { useRef } from "react";
import { chunk } from 'lodash';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const VerticalCarousel = (props) => {
  const carouselRef = useRef(null)
  const {
    data,
    title,
    icon,
    type,
    dataTestTitle = ''
  } = props;

  if (!data || data.length == 0) return null;

  const chunkedAwards = chunk(data, 3)

  return (
    <div className={`md:max-w-[70%] md:m-auto ${props.fullWidth ? 'max-w-full' : ''}`}>
      <div className="flex py-0 max-sm:justify-start max-xs:text-center justify-center">
        {icon}
        <h5 className="text-[1.5rem] font-bold leading-[1.334] m-0 text-center" data-test={dataTestTitle}>
          {title}
        </h5>
      </div>
      <Carousel
        ref={carouselRef}
        ssr={true}
        arrows={false}
        showDots={false}
        autoPlay={chunkedAwards.length > 1}
        centerMode={false}
        infinite={chunkedAwards.length > 1}
        containerClass="max-xs:px-4"
        dotListClass="[&_.react-multi-carousel-dot--active_button]:bg-primary-blue [&_button]:!border-0 [&_button]:bg-tertiary-blue"
        customTransition="transform 600ms ease-in-out"
        responsive={{
          desktop: {
            breakpoint: { max: 4000, min: 960 },
            items: 1,
            slidesToSlide: 1
          },
          tablet: {
            breakpoint: { max: 960, min: 600 },
            items: 1,
            slidesToSlide: 1
          },
          mobile: {
            breakpoint: { max: 600, min: 0 },
            items: 1,
            slidesToSlide: 1
          }
      }}>
        {chunkedAwards.map((chunkItems, chunkIndex) => {
          if (type === 'awards') {
            return (
              <div className="pt-4" key={`carousel-chunk:${chunkIndex}`}>
                {chunkItems.map(item => {
                  return (
                    <div
                      className="pb-4 font-bold text-primary-blue"
                      key={item.title ? item.title : item.accreditation.title}
                    >
                        {item.title ? item.title : item.accreditation.title}
                    </div>
                  )
                })}
              </div>
            )
          }

          return null
        })}
      </Carousel>
    </div>
  );
};

export default VerticalCarousel;
